import {isEmpty, isEqual, isNull, isUndefined} from "lodash/lang"
import {has} from "lodash/object"
import {UploaderEventBus} from "./events"
import {difference, remove} from "lodash/array"
import UploadFileHolder, {isUploadFileHolder} from "./file-holder"
import {UPLOADER_URL} from "../../globals"
import {apiAuth} from "../../main"
import {NetworkError, normalizeError} from "../errors"
import notify, {NOTIFICATION_TYPES, NotificationOptions} from "../notify"
import dialog, {DIALOG_TYPES, DialogOptions} from "../dialogs"
import {filter, includes} from "lodash/collection"
import {mapActions} from "vuex"
import store from "../../store"
import {GET_ID_PROCESSING, SET_MUST_CALCULATE_PROCESSING_DATA, GET_PROCESSING_DATA} from "../../store/modules/processing"
import {REMOVE_NON_UPLOADED_FILE, SET_NON_UPLOADED_FILES} from "../../store/modules/uploader"
import {deleteUploadedImage, postCoordsImages, postDataImages} from "../../api/api-project"
import {getFileExtension, readFileAsync, isZipMimetype} from "../utils"
import {imageMimeTypes} from "./mime-types"
import imageType from "image-type"
import UTIF from "utif"
import EXIF from "exif-js"
import {GEOREFERENCE_TYPES} from "../processings/constants"
import {getUserMaxImgData} from "@/api/api-billing"

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Vue from "vue";
Vue.use(Loading);


export const ImageUploaderMixin = {
  data: () => ({
    toUploadImages: [],
    uploadedImages: [],

    isUploadingImages: false,
    isEvaluatingImages: false,
    isLoadingImages: false,
    isDeletingImage: false,

    intImagesEvaluated: 0,
    intImagesToEvaluate: 0,

    imagesUploadProgress: 0,

    retrySetTimeout: null,
    listCoordsImages: [],
    firstVerification: true,
    firstVerificationImageData: true,
  }),
  methods: {
    startUploadImages(template) {
      this.isUploadingImages = true
      this.firstVerification = true
      this.firstVerificationImageData = true
      // this.loader = this.$loading.show({
      //   container: null,
      //   canCancel: false,
      //   backgroundColor: "#000",
      //   color: "#fff",
      //   opacity: 0.5,
      //   loader: "spinner",
      //   onCancel: this.onCancel,
      // });
      this.uploadNextImage(template)
    },
    async uploadNextImage(template) {
      if (isEmpty(this.toUploadImages)) return
      this.listCoordsImages = []
      if(this.toUploadImages[0].isZip) {
        // var specials = /[àèìòùáéíóúýñõãäëïöüÿÀÈÌÒÙÁÉÍÓÚÝÑÕÃÄËÏÖÜŸ!@#$%^&*+=[\]{};':"\\|,.<>?]+/;
        var specials = /[^A-Za-z0-9()\s_-]+/;
        if (specials.test(this.toUploadImages[0].name.split('.')[0])) {
          // if (this.firstVerification == true) {
          //   this.loader.hide();
          // }
          UploaderEventBus.$emit("zip-error", "invalid-zip-file")
          return
        }
        try {
          let imgQtt = 0
          this.$zipLib.workerScriptsPath = "/js/";
          let entries = await new this.$zipLib.ZipReader(new this.$zipLib.BlobReader(this.toUploadImages[0])).getEntries()
          if (entries && entries.length) {
            if (entries.length < 8 && this.processingTypeIsFP) {
              UploaderEventBus.$emit("zip-error", "length-images-in-zip")
              return
            } 
            const validFormats = ['jpg', 'jpeg', 'gif', 'tiff', 'tif']
            let innerFolder = false
            for (var i = 0; i < entries.length; i++) {
              var entry = entries[i].filename.split('.')
              var fileNameImg = entry[0]
              // var extension = entry[1]
              var extension = entry.pop()
              if (i == 0 && entries[i].directory) {
                innerFolder = true
                continue
              }
              var charSpecials = /[^A-Za-z0-9()\s_-]+/;
              if (i > 0 && charSpecials.test(fileNameImg)) {
                // if (this.firstVerification == true) {
                //   this.loader.hide();
                // }
                UploaderEventBus.$emit("zip-error", "invalid-files-chars")
                return
              }
              if (!validFormats.includes(extension.toLowerCase())) {
                // if (this.firstVerification == true) {
                //   this.loader.hide();
                // }
                UploaderEventBus.$emit("zip-error", "invalid-files")                
                return
              }
            }
            // ##############################################################################################
            // if (this._dataProcessing.ab_georeference_type == 'NOT_SET' && this.firstVerification == true) {
            //   const listCoordsImages = await new Promise((resolve, reject) => { 
            //     try {
            //       let temArrayCoords = [] 
            //       for (var j = 0; j < entries.length; j++) {
            //         const tags = new Promise((resolve, reject) => {  
            //           const blobWriter = new this.$zipLib.BlobWriter();
            //           console.log('Lendo arquivo: ', entries[j].filename)
            //           var entry_name = entries[j].filename.split('/')
            //           var filename = entry_name.pop()        
            //           entries[j].getData(blobWriter).then((blobFile) => {
            //             EXIF.getData(blobFile, function(err, tags) {
            //               window.decimalCoords = function(coords, ref) {
            //                 // console.log('THIS ', this)
            //                 let decimal_degrees = coords[0] + coords[1] / 60 + coords[2] / 3600
            //                 if (ref == "S" || ref == "W"){
            //                     decimal_degrees = -decimal_degrees
            //                 }
            //                 return decimal_degrees
            //               }                       
            //               if (err) reject(err);
            //               else {
            //                 let latitude = window.decimalCoords(this.exifdata.GPSLatitude, this.exifdata.GPSLatitudeRef)
            //                 let longitude = window.decimalCoords(this.exifdata.GPSLongitude, this.exifdata.GPSLongitudeRef)
            //                 let altitude = this.exifdata.GPSAltitude
            //                 tags = {'imagem': filename, 'longitude':longitude, 'latitude': latitude, 'altitude': altitude}
            //                 resolve(tags);
            //               }
            //             });
            //           })
            //         }); 
            //         temArrayCoords.push(tags)
            //       }
            //       resolve(temArrayCoords)
            //     } catch (error) {
            //       reject(error)
            //     }        
            //   })
            //   Promise.all(listCoordsImages).then((values) => {   
            //     let json_str_coords = JSON.stringify(values)
            //     console.log('JSON_ARRAY_COORDS >> ', json_str_coords)
            //     this.submitCoordsImages(json_str_coords)
            //     if (this.firstVerification == true){
            //       this.loader.hide();
            //     }                
            //     this.firstVerification = false               
            //     console.log(' <<<<<<<<<<< AFTER ARRAY_COORDS >>>>>>>>>>> ')
            //     // window.t1 = innerFolder
            //     // window.t2 = imgQtt
            //     // window.t3 = template
            //     imgQtt = innerFolder ? entries.length - 1 : entries.length
            //     console.log(imgQtt)
            //     UploaderEventBus.$emit("zip-read-error", false)
            //     this.checkZip(template, imgQtt)
            //   })
            //   .catch((error) => {
            //     if (this.firstVerification == true){
            //       this.loader.hide();
            //     }
            //     console.log(`Erro nas promises ${error}`)
            //     UploaderEventBus.$emit("zip-error", "not-get-metadata-exif")
            //   })
            // } else {
            //   console.log('<<<< . >>>>')
            //   if (this.firstVerification == true){
            //     this.loader.hide();
            //   }
            //   imgQtt = innerFolder ? entries.length - 1 : entries.length
            //   console.log(imgQtt)
            //   UploaderEventBus.$emit("zip-read-error", false)
            //   this.checkZip(template, imgQtt) 
            //   this.firstVerification = false             
            // }            
            // ############################################################################################## 
              // if (this.firstVerification == true){
              //   this.loader.hide();
              // }             
              imgQtt = innerFolder ? entries.length - 1 : entries.length
              console.log(imgQtt)
              UploaderEventBus.$emit("zip-read-error", false)
              this.checkZip(template, imgQtt) 
              this.firstVerification = false                                     
          } else {
            // if (this.firstVerification == true){
            //   this.loader.hide();
            // }
            this.$notify(new NotificationOptions({
              message: "Seu arquivo .zip parece estar vazio.",
              type: NOTIFICATION_TYPES.WARNING,
            }))
            UploaderEventBus.$emit("zip-error", "error")
          }
        }
        catch (e) {
          console.log("ERRO: ", e)
          // if (this.firstVerification == true) {
          //   this.loader.hide();
          // }
          UploaderEventBus.$emit("zip-read-error", true)
          this.$notify(new NotificationOptions({
            message: "A verificação do seu arquivo .zip será feita no nosso servidor e pode demorar um pouco. Por favor não recarregue a página.",
            type: NOTIFICATION_TYPES.WARNING,
          }))
          //UploaderEventBus.$emit("zip-error", "error")
          const currFileHolder = new UploadFileHolder(
            this.toUploadImages[0], this.onImageUploadProgress, this.onImageUploadEnded, this.onImageUploadError,
          )
          this.$set(this.toUploadImages, 0, currFileHolder)
          this.uploadImage(currFileHolder, 8)
          this.firstVerification = false
        }
      } else {
        console.log("Not .zip!")
        if (this._dataProcessing.ab_georeference_type == 'LAT_LONG' && this.firstVerificationImageData == true) {
          this.sendDataImagesBackend()
        }
        if (this._dataProcessing.ab_georeference_type == 'NOT_SET' && this.firstVerification == true) {          
          this.sendCoordsBackend()          
          const currFileHolder = new UploadFileHolder(
            this.toUploadImages[0], this.onImageUploadProgress, this.onImageUploadEnded, this.onImageUploadError,
          )
          this.$set(this.toUploadImages, 0, currFileHolder)
          this.uploadImage(currFileHolder)              
        } else {
          if (this.firstVerification == true) {
            // this.loader.hide();
          }          
          this.firstVerification = false
          const currFileHolder = new UploadFileHolder(
            this.toUploadImages[0], this.onImageUploadProgress, this.onImageUploadEnded, this.onImageUploadError,
          )
          this.$set(this.toUploadImages, 0, currFileHolder)
          this.uploadImage(currFileHolder)          
        }      
      }
    },
    async sendCoordsBackend() {
      this.firstVerification = false
      const listCoordsImages = await new Promise((resolve, reject) => { 
        try {
          let tempArrayCoords = [] 
          for (let index = 0; index < this.toUploadImages.length; index++) {
            const tags = new Promise((resolve, reject) => {               
              EXIF.getData(this.toUploadImages[index], function(err, tags) { 
                  window.decimalCoords = function(coords, ref) {
                    let decimal_degrees = coords[0] + coords[1] / 60 + coords[2] / 3600
                    if (ref == "S" || ref == "W"){
                        decimal_degrees = -decimal_degrees
                    }
                    return decimal_degrees
                  }                       
                  if (err) reject(err);
                  else {
                    let latitude = window.decimalCoords(this.exifdata.GPSLatitude, this.exifdata.GPSLatitudeRef)
                    let longitude = window.decimalCoords(this.exifdata.GPSLongitude, this.exifdata.GPSLongitudeRef)
                    let altitude = this.exifdata.GPSAltitude
                    tags = {'imagem': this.name, 'longitude':longitude, 'latitude': latitude, 'altitude': altitude}
                    resolve(tags);
                  }
              });
            }); 
            tempArrayCoords.push(tags)               
          }
          resolve(tempArrayCoords)
        } catch (error) {
          console.error(error);
          reject(error)
        }        
      })
      Promise.all(listCoordsImages).then((values) => {        
        let json_str_coords = JSON.stringify(values)
        console.log('JSON_ARRAY_COORDS >> ', json_str_coords)
        this.submitCoordsImages(json_str_coords)
        // this.firstVerification = false
        // this.loader.hide();      
      });
    },
    async sendDataImagesBackend() {
      this.firstVerificationImageData = false
      const listDataImages = await new Promise((resolve, reject) => { 
        try {
          let tempArrayDataImages = [] 
          for (let index = 0; index < this.toUploadImages.length; index++) {
            const dataImg = new Promise((resolve, reject) => {               
              EXIF.getData(this.toUploadImages[index], function(err, dataImg) {                     
                  if (err) reject(err);
                  else {
                    let date_time = this.exifdata.DateTime
                    let date_time_original = this.exifdata.DateTimeOriginal
                    let date_time_digitized = this.exifdata.DateTimeDigitized
                    dataImg = {'imagem': this.name, 'date_time':date_time, 'date_time_original': date_time_original, 'date_time_digitized': date_time_digitized}
                    resolve(dataImg);
                  }
              });
            }); 
            tempArrayDataImages.push(dataImg)               
          }
          resolve(tempArrayDataImages)
        } catch (error) {
          console.error(error);
          reject(error)
        }        
      })
      Promise.all(listDataImages).then((values) => {        
        let json_str_data_images = JSON.stringify(values)
        console.log('JSON_ARRAY_DATA_IMAGES >> ', json_str_data_images)
        this.submitDataImages(json_str_data_images)
        // this.firstVerification = false
        // this.loader.hide();      
      });
    },
    submitDataImages(json_str_data_images){
      const authToken = this.$apiAuth.getAuthToken()
      postDataImages(authToken, this._imgMixinIdProcessing, json_str_data_images)
      .then(() => {
        console.log('JSON com dados das imagens foi enviada com sucesso!')
      })
      .catch(() => {
        this.$notify(new NotificationOptions({
          message: "Erro ao realizar o upload com os dados das images. Por favor tente novamente em alguns minutos",
          type: NOTIFICATION_TYPES.ERROR,
        }))
      })
    },    
    submitCoordsImages(json_str_coords){
      const authToken = this.$apiAuth.getAuthToken()
      postCoordsImages(authToken, this._imgMixinIdProcessing, json_str_coords)
      .then(() => {
        console.log('JSON com coordenadas das imagens foi enviada com sucesso!')
      })
      .catch(() => {
        this.$notify(new NotificationOptions({
          message: "Erro ao realizar o upload das coords. Por favor tente novamente em alguns minutos",
          type: NOTIFICATION_TYPES.ERROR,
        }))
      })
    },
    checkZip(template, imgQtt) {
      const authToken = this.$apiAuth.getAuthToken()
      getUserMaxImgData(authToken)
      .then((res) => {
        let data = res.data.data
        let validImgQtt = true
        if (template.includes("RGB")){
          if (0 < data.max_img_rgb && data.max_img_rgb < imgQtt) {
            validImgQtt = false
          }
        }
        else if (template == 'AGRICOLA_MULTISPECTRAL'){
          if (0 < data.max_img_multispectral && data.max_img_multispectral< imgQtt) {
            validImgQtt = false
          }
        }
        if (validImgQtt) {
          const currFileHolder = new UploadFileHolder(
            this.toUploadImages[0], this.onImageUploadProgress, this.onImageUploadEnded, this.onImageUploadError,
          )
          this.$set(this.toUploadImages, 0, currFileHolder)
          this.uploadImage(currFileHolder, imgQtt)
        } else {
          UploaderEventBus.$emit("zip-error", "invalid-qtt", data)
        }
      })
      .catch(() => {
        this.$notify(new NotificationOptions({
          message: "Erro ao iniciar upload do arquivo. Por favor tente novamente mais tarde",
          type: NOTIFICATION_TYPES.ERROR,
        }))
        UploaderEventBus.$emit("zip-error", "error")
      })
    },
    uploadImage(uploadFileHolder, imgQtt) {
      const fileUploadUrl = `${UPLOADER_URL}/upload/image/${this._imgMixinIdProcessing}`
      const authToken = apiAuth.getAuthToken()
      uploadFileHolder.startUpload(
        fileUploadUrl,
        `Bearer ${authToken}`,
        imgQtt
      )
    },
    // Full Processing
    addImagesFullProcessing(files, isMultispectral, checkGeoTag, hasFlightLog) {
      this.isEvaluatingImages = true

      // Filtra os arquivos com nomes repetidos
      const toUploadedFileNames = [
        ...this.toUploadImages.map((obj) => obj.name),
        ...this.uploadedImages.map((obj) => obj.name),
      ]
      const newFileNames = files.map((obj) => obj.name)
      const intersectedFilesName = toUploadedFileNames.filter(name => newFileNames.includes(name))

      files = files.filter((obj) => !intersectedFilesName.includes(obj.name))

      if (!isEmpty(intersectedFilesName)) {
        dialog(new DialogOptions({
          title: "Imagens já adicionadas",
          content: `As seguintes imagens já foram adicionadas ao upload: <br> ${intersectedFilesName.join("<br>")}`,
          cancelText: "Ok, Entendi"
        }))
      }

      if (isEmpty(files)) {
        this.isEvaluatingImages = false
        return
      }

      for (let index = 0; index < files.length; index++) {
        console.log('VALIDATE REGEX IMAGE >> ', files[index].name.split('.')[0])
        // var specials2 = /[!@#$%^&*+=[\]{};':"\\|,.<>?]+/;
        var specials2 = /[^A-Za-z0-9()\s_-]+/;
        let name_image = files[index].name.split('.')[0]
        if (specials2.test(name_image)) {
          console.log("IMAGEM INVALIDA: ", name_image)
          dialog(new DialogOptions({
            title: "Imagem com caracteres inválidos",            
            content: `A imagem com o nome (${files[index].name}) possui caracteres não permitido. Verifique e tente novamente.`,
            cancelText: "Ok, Entendi"
          }))
          this.isEvaluatingImages = false
          return
        }   
      }       

      this.evaluateFilesAsImages(files, isMultispectral, checkGeoTag)
        .then(res => {
          this.onFPEvaluateComplete(res.filesData, isMultispectral, hasFlightLog)
        })
    },
    onFPEvaluateComplete(filesData, isMultispectral, hasFlightLog) {
      let imageFiles = filter(filesData, value => value["isImage"])
            
      let fileName = '';
      let isZipFile = false

      if (!isEmpty(filesData) && !isEmpty(filesData[0].name)) {
        fileName = filesData[0].name;
        isZipFile = fileName.includes('.zip') ? true : false;
      }
      
      let nonImageFiles = filter(filesData, value => !value["isImage"])
      let zipTypes = ["application/zip", "application/x-zip-compressed", "application/octet-stream", "application/x-compress", "application/x-compressed", "multipart/x-zip"]
      let nonRGBFiles;

      if (!isZipFile){
        if (isMultispectral) {
          // Checagem de imagens que não são .tif
          let nonValidFiles = filter(imageFiles, (image) => !["image/tiff", "image/jpeg"].includes(image.imageType.mime))
          nonValidFiles = filter(nonValidFiles, (image) => !zipTypes.includes(image.type))
          if (!isEmpty(nonValidFiles)) {
            const filesName = nonValidFiles.map(file => "- " + file.name).join("<br>")
            dialog(new DialogOptions({
              title: "Arquivo(s) não detectado(s) como .tif, .jpeg, .zip",
              content: `${filesName}`,
              confirmText: "Entendi",
              type: DIALOG_TYPES.ALERT,
            }))
          }
          imageFiles = difference(imageFiles, nonValidFiles)
        } else {
          // Checagem de imagens que não são .png ou .jpg
          nonRGBFiles = filter(imageFiles, (image) => !["image/png", "image/jpeg"].includes(image.imageType.mime))
          nonRGBFiles = filter(nonRGBFiles, (image) => !zipTypes.includes(image.type))
          if (!isEmpty(nonRGBFiles)) {
            const filesName = nonRGBFiles.map(file => "- " + file.name).join("<br>")
            dialog(new DialogOptions({
              title: "Arquivo(s) não detectado(s) como .png, .jpeg, .zip:",
              content: `${filesName}`,
              confirmText: "Entendi",
              type: DIALOG_TYPES.ALERT,
            }))
          }
        }
        imageFiles = difference(imageFiles, nonRGBFiles)
        nonImageFiles = filter(nonImageFiles, (image) => !zipTypes.includes(image.type))
      }
      let allFiles = filesData.concat(this.uploadedImages, this.toUploadImages)
      let hasError = false
      for (const arq of allFiles){
        if (arq.isZip && allFiles.length >1){
          hasError=true
        }
      }
      if (hasError){
        const filesName = allFiles.map(file => file.name).join(", ")
        dialog(new DialogOptions({
          title: "É possível o envio de apenas um arquivo compactado, arquivos encontrados: ",
          content: `${filesName}`,
          confirmText: "Entendi",
          type: DIALOG_TYPES.ALERT,
        }))
        imageFiles = difference(imageFiles, allFiles)
      }
      // Avisa o usuario safado que ele tá fazendo safadagem
      if (!isEmpty(nonImageFiles)  && !isZipFile) {
        const filesName = nonImageFiles.map(file => file.name).join(", ")
        dialog(new DialogOptions({
          title: "Arquivo(s) não detectado(s) como imagens: ",
          content: `${filesName}`,
          confirmText: "Entendi",
          type: DIALOG_TYPES.ALERT,
        }))
      }

      if (isEmpty(imageFiles)  && !isZipFile) {
        this.isEvaluatingImages = false
        return
      }

      if (!hasFlightLog && !isZipFile) {
        const nonGeotaggedImages = filter(imageFiles, value => !value["isGeotagged"])

        // Avisa que o usuario é burro
        if (!isEmpty(nonGeotaggedImages)) {
          if (!isMultispectral) {
            const filesName = nonGeotaggedImages.map(file => file.name).join(", ")
            dialog(new DialogOptions({
              title: "Arquivo(s) detectado(s) sem georreferenciamento:",
              content: `${filesName}`,
              confirmText: "Entendi",
              type: DIALOG_TYPES.ALERT,
            }))
          } else {
            dialog(new DialogOptions({
              title: "Erro ao adicionar arquivo(s)",
              content: "Algumas de suas imagens não tiveram georreferenciamento detectado. <br> " +
                "Por favor verifique o geotag de suas imagens e faça o upload novamente",
              confirmText: "Entendi",
              type: DIALOG_TYPES.ALERT,
            }))
            this.isEvaluatingImages = false
            return
          }

          imageFiles = filter(filesData, ["isGeotagged", true])
        }
      }

      if(isZipFile && !hasError) {
        imageFiles = filesData;
      }

      this.toUploadImages = [...this.toUploadImages, ...imageFiles]
      this._imgMixinSetNonUploadedFiles({
        idProcessing: this._imgMixinIdProcessing,
        fileList: this.toUploadImages.map(obj => obj.name),
      })
      this.isEvaluatingImages = false
    },
    // Tilling
    addImagesTilling(file) {
      if (!isEmpty(this.uploadedImages)) {
        notify(new NotificationOptions({
          message: "Já existe um arquivo .tif, para adicionar outro remova o existente",
          duration: 6000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        return
      }
      this.isEvaluatingImages = true

      this.evaluateFilesAsImages([file])
        .then(res => {
          this.onTillingEvaluateComplete(res.filesData)
        })
    },
    onTillingEvaluateComplete(filesData) {
      //Fazer os Ortomosaico permitirem os ZIP ou 7z ou rar ?
      const nonImageFiles = filter(filesData, value => !value["isImage"])
      // Avisa o usuario safado que ele tá fazendo safadagem
      if (!isEmpty(nonImageFiles)) {
        const fileName = nonImageFiles[0].name
        notify(new NotificationOptions({
          message: `Erro ao adicionar ${fileName}, o arquivo não foi detectado como imagem.`,
          duration: 10000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
      }

      let imageFiles = filter(filesData, value => value["isImage"])
      if (isEmpty(imageFiles)) {
        this.isEvaluatingImages = false
        return
      }

      const imageFile = imageFiles[0]
      if (imageFile.imageType.mime !== "image/tiff") {
        notify(new NotificationOptions({
          message: `Erro ao adicionar imagem: formato esperado .tif. A imagem ${imageFile.name} não foi detectada como tif.`,
          duration: 10000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        this.isEvaluatingImages = false
        return
      }

      const minMbs = 5
      if (imageFile.size < minMbs * 1000000) {
        // Minimo de 10 megas para TIF
        notify(new NotificationOptions({
          message: `Erro ao adicionar imagem: O arquivo .tif precisa ter no minimo ${minMbs} Megabytes`,
          duration: 10000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        this.isEvaluatingImages = false
        return
      }

      this.toUploadImages = [imageFile]
      this.isEvaluatingImages = false
    },

    removeImage(uploadFileHolder) {
      if (isUploadFileHolder(uploadFileHolder) && uploadFileHolder.uploadCompleted) {
        dialog(new DialogOptions({
          title: "Tem certeza?",
          content: `Você tem certeza que deseja deletar a image ${uploadFileHolder.name}?`,
          confirmText: "SIM, DELETAR IMAGEM",
          cancelText: "CANCELAR",
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: () => {
            this.removeUploadedImage(uploadFileHolder)
          },
        }))
      } else {
        this.removeImageToUpload(uploadFileHolder)
      }
    },
    removeImageToUpload(uploadFileHolder) {
      this.toUploadImages = filter(this.toUploadImages, obj => !isEqual(uploadFileHolder.name, obj.name))
      this._imgMixinRemoveNonUploadedFile({idProcessing: this._imgMixinIdProcessing, fileName: uploadFileHolder.name})
    },
    removeUploadedImage(uploadFileHolder) {
      this.isDeletingImage = true
      const authToken = apiAuth.getAuthToken()
      deleteUploadedImage(authToken, this._imgMixinIdProcessing, uploadFileHolder.name)
        .then(() => {
          this.uploadedImages = filter(this.uploadedImages, obj => !isEqual(uploadFileHolder.name, obj.name))
          this.isDeletingImage = false

          if (isEmpty(this.uploadedImages)) this.imagesUploadProgress = 0
          else this.onImageUploadProgress(0)
          this._imgMixinSetMustCalculateProcessingData(true)
        })
        .catch((err) => {
          notify(new NotificationOptions({
            message: `Ocorreu um erro ao remover o arquivo ${uploadFileHolder.name}. Cod.: ${err.response.data.code}`,
            type: NOTIFICATION_TYPES.ERROR,
          }))
          this.isDeletingImage = false
        })
    },

    // Upload handlers
    onImageUploadProgress(progress) {
      const totalFiles = this.fullImagesList.length
      let currIdx = this.uploadedImages.length

      let totalProgress = Math.ceil(progress / totalFiles + (currIdx * (100 / totalFiles)))
      if (totalProgress >= 100) this.imagesUploadProgress = 100
      else this.imagesUploadProgress = totalProgress
    },
    onImageUploadEnded(uploadFileHolder) {
      remove(this.toUploadImages, obj => isEqual(uploadFileHolder.name, obj.name))
      this.uploadedImages.push(uploadFileHolder)

      this._imgMixinRemoveNonUploadedFile({idProcessing: this._imgMixinIdProcessing, fileName: uploadFileHolder.name})

      if (isEmpty(this.toUploadImages)) {
        this.isUploadingImages = false
        UploaderEventBus.$emit("upload-finished")
        return
      }

      if (this.uploadedImages.length % this.imagesPerPage === 0)
        UploaderEventBus.$emit("change-page", (this.uploadedImages.length / this.imagesPerPage))

      this._imgMixinSetMustCalculateProcessingData(true)

      this.uploadNextImage()
    },
    onImageUploadError(err, uploadFileHolder) {
      const normErr = normalizeError(err)
      if (includes([500, 503], normErr.statusCode)) {
        notify(new NotificationOptions({
          message: "Ocorreu um erro durante seu upload, por favor, tente novamente mais tarde. Se o problema persistir entre em contato conosco pelo chat.",
          duration: 4 * 3600 * 1000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        this.toUploadImages[0].uploadProgress = 0
        this.toUploadImages[0].uploadStarted = false
        this.toUploadImages[0].uploadCompleted = false
        this.isUploadingImages = false
      } else if (normErr instanceof NetworkError) {
        const retrySecs = 10
        notify(new NotificationOptions({
          message: `Foi detectado uma falha de conexão com a internet.
          O sistema tentará reconectar em ${retrySecs} segundos.
          Por favor, verifique sua internet.`,
          duration: (retrySecs * 1000) - 200,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        if (this.retrySetTimeout) clearTimeout(this.retrySetTimeout)
        this.retrySetTimeout = setTimeout(function () {
          this.uploadImage(uploadFileHolder)
        }.bind(this), retrySecs * 1000)
      }
    },
    async evaluateFilesAsImages(files, isMultispectral, checkGeoTag) {
      async function loadFileContent(file, sliceSize) {
        let fileData = null

        if (sliceSize) fileData = new Blob([file]).slice(0, sliceSize)
        else fileData = new Blob([file])

        let contentBuffer = null
        try {
          contentBuffer = await readFileAsync(fileData)
        } catch (err) {
          console.error(err)
        }
        return contentBuffer
      }

      this.intImagesToEvaluate = files.length
      this.intImagesEvaluated = 0

      let checkImagesStep = null
      if (isMultispectral && checkGeoTag) checkImagesStep = 100

      const filesData = []
      for (const file of files) {
        console.log(file.type)
        if (file.size > (300 * 1000000)) {
          // Se a imagem for mais de 300 Mb então a checagem acontece de forma superficial,
          //  sem carregar a imagem, isso aqui ainda acontece pois algumas coisas estranhas
          //  aconteceram com imagens tiffs maiores que 1Gb, algumas vezes elas não eram
          //  detectadas pela função imageType, então usa esse fallback por enquanto.
          const fileType = file.type
          const fileExtension = getFileExtension(file.name)
          if (!imageMimeTypes.includes(fileType)) {
            file.isImage = false
            file.isGeotagged = false
            filesData.push(file)
            continue
          }
          file.imageType = {
            mime: fileType,
            ext: fileExtension,
          }
          file.isImage = true
          file.isGeotagged = false
          if (isZipMimetype(file.type)) {
            console.log("Zip Mimetype ok")
            file.isZip = true
            file.isGeotagged = true
          }
          filesData.push(file)
          continue
        }
        const contentBuffer = await loadFileContent(file, Math.pow(2, 16))
        let fileType = imageType(new Uint8Array(contentBuffer))
        if (fileType) {
          file.isImage = true
          if (checkGeoTag) {
            if (fileType.mime === "image/tiff") {
              // Se for multispectral apenas checa uma em cada 10 imagens pelo GeoTag
              if (checkImagesStep) {
                if (this.intImagesEvaluated % checkImagesStep === 0) {
                  const tiffContentBuffer = await loadFileContent(file)
                  const ifds = UTIF.decode(tiffContentBuffer)
                  file.isGeotagged = has(ifds[0], "t34853")
                } else {
                  file.isGeotagged = true
                }
              }
            } else {
              const exifTags = EXIF.readFromBinaryFile(contentBuffer)
              file.isGeotagged =
                !isEmpty(exifTags["GPSLatitude"]) &&
                !isNull(exifTags["GPSLatitude"]) &&
                !isUndefined(exifTags["GPSLatitude"])
            }
          }
        } else if(isZipMimetype(file.type)){
          file.isImage = true
          file.isGeotagged = true
          fileType = file.type
          file.isZip = true
        } else {
          file.isImage = false
          file.isGeotagged = false
        }
        file.imageType = fileType
        filesData.push(file)
        this.intImagesEvaluated++
      }

      return {filesData}
    },
    ...mapActions({
      _imgMixinSetNonUploadedFiles: SET_NON_UPLOADED_FILES,
      _imgMixinRemoveNonUploadedFile: REMOVE_NON_UPLOADED_FILE,
      _imgMixinSetMustCalculateProcessingData: SET_MUST_CALCULATE_PROCESSING_DATA,
    }),
  },
  computed: {
    fullImagesList() {
      return [...this.uploadedImages, ...this.toUploadImages]
    },
    _imgMixinIdProcessing() {
      return store.getters[GET_ID_PROCESSING]
    },
    _dataProcessing() {
      return store.getters[GET_PROCESSING_DATA]
    },    
    isFinishingStream() {
      return this.isUploadingImages && this.imagesUploadProgress >= 100 && this.toUploadImages.length === 1
    },
  },
}

export const flightLogUploaderMixin = {
  data: () => ({
    flightLogFile: null,
    flightLogUploadProgress: 0,
    isFlightLogUploaded: false,
    isUploadingFlightLog: false,

    flightLogInput: null,
  }),
  methods: {
    addFlightLog(file, abGeoreferenceType) {
      if (!file) return

      if (this.isFlightLogUploaded) {
        if (isEqual(file.name, this.flightLogFile.name)) return

        // Novo arquivo de log de voo
        this.isFlightLogUploaded = false
        this.flightLogUploadProgress = 0
      }

      let fileExtension = null
      if (isEqual(abGeoreferenceType, GEOREFERENCE_TYPES.THREE_D_ROBOTICS))
        fileExtension = ".log"
      else if ([GEOREFERENCE_TYPES.LAT_LONG, GEOREFERENCE_TYPES.LONG_LAT].includes(abGeoreferenceType))
        fileExtension = ".txt"
      else return // shhhhh

      const fileName = file.name
      if (!fileName.endsWith(fileExtension)) {
        let message = null
        if ([GEOREFERENCE_TYPES.LAT_LONG, GEOREFERENCE_TYPES.LONG_LAT].includes(abGeoreferenceType))
          message = "Erro no log de voo: formato esperado .txt. " +
            "O formato de arquivo não é válido com o tipo de log de voo especificado no projeto. "
        else if (fileName.endsWith(".bin"))
          message = "Erro no log de voo: formato esperado .log. " +
            "Foi identificado que o log d e voo adicionado é um arquivo no formato .bin, por favor, converta-o para .log."
        else
          message = "Erro no log de voo: formato esperado .log. " +
            "O formato de arquivo não é válido com o tipo de log de voo especificado no projeto. "

        notify(new NotificationOptions({
          message: message,
          duration: 15000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        this.flightLogFile = null
        return
      }

      this.flightLogFile = new UploadFileHolder(
        file, this.onFlightLogUploadProgress, this.onFlightLogUploadEnded, this.onFlightLogUploadError,
      )
    },
    uploadFlightLog(abGeoreferenceType) {
      if (!this.flightLogFile) return
      const fileUploadUrl = `${UPLOADER_URL}/upload/flight-log/${this._flightLogMixinIdProcessing}`

      let fileName = null
      if (isEqual(GEOREFERENCE_TYPES.THREE_D_ROBOTICS, abGeoreferenceType)) fileName = "flight_log.log"
      else fileName = "flight_log.csv"

      const authToken = apiAuth.getAuthToken()
      this.flightLogFile.startUpload(
        fileUploadUrl,
        `Bearer ${authToken}`,
        fileName,
      )

      this.isUploadingFlightLog = true
    },
    onFlightLogUploadProgress(progress) {
      this.flightLogUploadProgress = Math.trunc(progress)
    },
    onFlightLogUploadEnded() {
      this.isUploadingFlightLog = false
      this.isFlightLogUploaded = true
      UploaderEventBus.$emit("upload-finished")
    },
    onFlightLogUploadError(err) {
      const normErr = normalizeError(err)
      if (includes([500, 503], normErr.statusCode)) {
        notify(new NotificationOptions({
          message: "Ocorreu um erro durante seu upload, por favor, tente novamente mais tarde. Se o problema persistir entre em contato conosco pelo chat.",
          duration: 4 * 3600 * 1000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
      } else if (normErr instanceof NetworkError) {
        const retrySecs = 10
        notify(new NotificationOptions({
          message: `Foi detectado uma falha de conexão com a internet.
          O sistema tentará reconectar em ${retrySecs} segundos.
          Por favor, verifique sua internet.`,
          duration: (retrySecs * 1000) - 200,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        if (this.retrySetTimeout) clearTimeout(this.retrySetTimeout)
        this.retrySetTimeout = setTimeout(function () {
          this.uploadFlightLog()
        }.bind(this), retrySecs * 1000)
      }
    },
  },
  computed: {
    _flightLogMixinIdProcessing() {
      return store.getters[GET_ID_PROCESSING]
    },
  },
}

export const gcpUploaderMixin = {
  data: () => ({
    gcpFile: null,
    isGcpUploaded: false,
    gcpUploadProgress: 0,
    isUploadingGcp: false,

    gcpInput: null,
  }),
  methods: {
    uploadGcp() {
      if (!this.gcpFile) return

      const fileUploadUrl = `${UPLOADER_URL}/upload/gcp/${this._gcpMixinIdProcessing}`
      const fileName = "gcp.txt"

      const authToken = this.$apiAuth.getAuthToken()
      this.gcpFile.startUpload(
        fileUploadUrl, `Bearer ${authToken}`, fileName,
      )

      this.isUploadingGcp = true
    },
    addGcpToUpload(gcpFile) {
      if (!gcpFile) return
      if (this.isGcpUploaded) {
        if (isEqual(gcpFile.name, this.gcpFile.name)) return

        // Novo arquivo de GCP
        this.isGcpUploaded = false
        this.gcpUploadProgress = 0
      }
      const fileName = gcpFile.name
      if (!fileName.endsWith(".txt")) {
        notify(new NotificationOptions({
          message: "Erro em pontos de controle: formato esperado .txt. " +
            "O formato de arquivo dos pontos de controle não é válido.",
          type: NOTIFICATION_TYPES.WARNING,
          duration: 15000,
        }))
        this.gcpFile = null
        return
      }
      this.gcpFile = new UploadFileHolder(
        gcpFile, this.onGcpUploadProgress, this.onGcpUploadEnded, this.onGcpUploadError,
      )
    },
    onGcpUploadProgress(progress) {
      this.gcpUploadProgress = Math.trunc(progress)
    },
    onGcpUploadEnded() {
      this.isUploadingGcp = false
      this.isGcpUploaded = true
      UploaderEventBus.$emit("upload-finished")
    },
    onGcpUploadError(err) {
      const normErr = normalizeError(err)
      if (includes([500, 503], normErr.statusCode)) {
        notify(new NotificationOptions({
          message: "Ocorreu um erro durante seu upload, por favor, tente novamente mais tarde. Se o problema persistir entre em contato conosco pelo chat.",
          duration: 4 * 3600 * 1000,
          type: NOTIFICATION_TYPES.WARNING,
        }))
      } else if (normErr instanceof NetworkError) {
        const retrySecs = 10
        notify(new NotificationOptions({
          message: `Foi detectado uma falha de conexão com a internet.
          O sistema tentará reconectar em ${retrySecs} segundos.
          Por favor, verifique sua internet.`,
          duration: (retrySecs * 1000) - 200,
          type: NOTIFICATION_TYPES.WARNING,
        }))
        if (this.retrySetTimeout) clearTimeout(this.retrySetTimeout)
        this.retrySetTimeout = setTimeout(function () {
          // this.uploadFlightLog()
        }.bind(this), retrySecs * 1000)
      }
    },
  },
  computed: {
    _gcpMixinIdProcessing() {
      return store.getters[GET_ID_PROCESSING]
    },
  },
}
